import axiosInstance from '../utils/axiosConfig';
import { Session, TeamPowerup } from '../types/session';

export const sessionApi = {

  getAllSession:async ()=>{
    const  response =  await axiosInstance.get('/api/sessions');
    return response.data

  },

  getSessionsByUserId:async ()=>{
    const  response =  await axiosInstance.get('/api/sessions/user');
    return response.data

  },
    
    createSession: async (session: Session) => {
        const response = await axiosInstance.post('/api/sessions/with-questions', session);


        return response.data;
    },
    getSession: async (sessionId: string) => {
        const response = await axiosInstance.get(`/api/sessions/${sessionId}`);
        return response.data;
    },
    updateSession: async (session: Session) : Promise<Session> => {
      try  {
        const response = await axiosInstance.put(`/api/sessions/${session.sessionId}/update`, session);
        return response.data;
      }catch ( error ){
        throw error;
      }
    },
    deleteSession: async (sessionId: string) => {
        const response = await axiosInstance.delete(`/api/sessions/${sessionId}`);
        return response.data;
    }           ,

 
updateQuestionState: async (
  sessionId: string, 
  questionId: string, 
  teamId: string,
  team1Powerups: TeamPowerup[],
  team2Powerups: TeamPowerup[]
): Promise<Session> => {
  try {
    // Match the PowerupsRequest structure exactly
    const response = await axiosInstance.put<Session>(
      `/api/sessions/${sessionId}/question/${questionId}/answer`,
      {
        team1Powerups: team1Powerups,
        team2Powerups: team2Powerups
      },
      {
        params: {
          teamId
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating question state:', error);
    throw error;
  }
},

    getQuestion: async (questionId: string) => {
        const response = await axiosInstance.get(`/api/questions/${questionId}`);
        return response.data;
    },

  reportQuestion: async (questionId: string, reportMessage: string) => {
    try {
      const response = await axiosInstance.post(`/api/question-reports/question/${questionId}`, reportMessage);
      return response.data;
    } catch (error) {
      console.error('Error reporting question:', error);
      throw error;
    }
  }
}
